import React, {useRef, useState} from "react";
import "./Header.scss";
import HeaderPageList from "./HeaderPageList";
import UserInfo from "./UserInfo";
import Socials from "./Socials";
import {Link} from "react-router-dom";
import HomeLogo from "./HomeLogo";

const Header = () => {
  const navbarCollapseRef = useRef<HTMLDivElement | null>(null);

  const handleNavLinkClick = () => {
    if (navbarCollapseRef.current && navbarCollapseRef.current.classList.contains('show')) {
      navbarCollapseRef.current.classList.remove('show');
    }
  };

  return (
      <>
        <header className="px-0 px-lg-4 pt-2">
          <div className="container">
            <div className="row gx-0 align-items-center">
              <div className="col">
                <nav className="navbar navbar-expand-lg">
                  <HomeLogo/>
                  <Socials />

                  <UserInfo />
                  <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMenu" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                  </button>
                  <div className="navbar-collapse collapse me-1" id="navbarMenu" ref={navbarCollapseRef}>
                    <ul className="flex-lg-row align-items-center gap-1 navbar-nav ms-auto">
                      <li className="nav-item text-center">
                        <a href="/post" className="nav-link text-decoration-none">
                          News
                        </a>
                      </li>
                      <li>
                        <a href="/event/season-11" className="nav-link text-decoration-none">SEASON 11</a>
                      </li>
                      <li className="nav-item text-center">
                        <Link to={'/seasons'} className={`nav-link text-decoration-none `} onClick={handleNavLinkClick}>
                          OTHER SEASONS
                        </Link>
                      </li>
                      <HeaderPageList onClick={handleNavLinkClick} />
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </header>
      </>
  );
};

export default Header;
